import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useIdleTimer from '../hooks/useIdleTimer';
import { PRIZE_DAILY_LIMIT, saveData, removeAllAnswers } from '../utils';

import people from '../assets/images/people.png';
import patternResults from '../assets/images/pattern-results.png';

import Button from '../components/Button';

const Results = () => {
  const [prizeOut, setPrizeOut] = useState(false);
  const [isQualified, setQualified] = useState(false);

  const userAnswers = localStorage.getItem('user-answers');
  const isPlayed = localStorage.getItem('is-played') && JSON.parse(localStorage.getItem('is-played'));

  const { t } = useTranslation();

  const startTime = useSelector(({ time }) => time.startTime);

  const navigate = useNavigate();
  const {
    state: { correctAnswers, prizeWonToday },
  } = useLocation();

  const goNext = () => {
    isQualified ? navigate('/game') : navigate('/');
  };

  useEffect(() => {
    console.log(correctAnswers, prizeWonToday, isPlayed);

    if (prizeWonToday > PRIZE_DAILY_LIMIT || isPlayed) setPrizeOut(true);

    if (correctAnswers >= 6 && prizeWonToday < PRIZE_DAILY_LIMIT && !isPlayed) {
      setQualified(true);
    } else {
      if (userAnswers) {
        saveData(startTime, null, 'complete');

        localStorage.removeItem('user-info');
        localStorage.removeItem('user-answers');
        removeAllAnswers();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(prizeOut);

  useIdleTimer();

  return (
    <>
      <div className="md:text-[2.8rem] lg:text-[5.2rem] text-2xl font-bold leading-tight md:px-[6rem] px-[4rem] lg:mt-[10rem] mt-[4rem] relative z-10">
        <h1 className="text-brandAccent">{t('results1')}</h1>
        <p className="lg:text-6xl my-10">{`${t('results2')} ${correctAnswers} ${t('results3')}`}</p>
      </div>

      <Button onClick={goNext}>{isQualified ? `${t('nowSpinToWin')}` : `${t('thankYou')}`}</Button>

      <img src={patternResults} alt="pattern" className="lg:w-full w-[60%] absolute left-0 bottom-0" />
      <img src={people} alt="people" className="absolute left-0 bottom-0" />
    </>
  );
};

export default Results;
